/* SEAR - minimal progressive enhancement.
   Everything here is optional: the site works fully with JS disabled.
   All motion is gated on prefers-reduced-motion. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal -------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;

    // Reduced motion, or no IntersectionObserver: show everything immediately.
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-revealed'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
    // threshold 0, not a ratio: an element taller than the viewport can never
    // show 8% of itself at once, so a ratio threshold left long sections hidden.

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Mobile nav drawer ---------------------------------------------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-mobile-toggle]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    if (!toggle || !drawer) return;

    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }

    function close() {
      drawer.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    toggle.addEventListener('click', function () {
      if (drawer.hidden) { open(); } else { close(); }
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.matches('[data-mobile-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });
  }

  /* ---- Quantity stepper ------------------------------------------------ */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input[type="number"]');
      if (!input) return;
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-qty-step]');
        if (!btn) return;
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var next = (parseInt(input.value, 10) || min) + step;
        input.value = next < min ? min : next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }


  /* ---- Count-up stats ---------------------------------------------------- */
  function initCountUp() {
    var els = document.querySelectorAll('[data-countup]');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) return; // final value already in the HTML

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-countup'));
        if (isNaN(target)) return;
        var dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
        var pre = el.getAttribute('data-prefix') || '';
        var suf = el.getAttribute('data-suffix') || '';
        var t0 = performance.now();
        function tick(now) {
          var p = Math.min(1, (now - t0) / 1150);
          var v = target * (1 - Math.pow(1 - p, 3));
          el.textContent = pre + (dec ? v.toFixed(dec) : Math.round(v).toLocaleString('en-GB')) + suf;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Parts diagram ----------------------------------------------------- */
  function initParts() {
    var pins = [].slice.call(document.querySelectorAll('.sear-pin'));
    var rows = [].slice.call(document.querySelectorAll('.sear-partrow'));
    if (!pins.length) return;

    function set(n, on) {
      pins.forEach(function (p) { p.classList.toggle('is-on', on && p.dataset.part === n); });
      rows.forEach(function (r) { r.classList.toggle('is-on', on && r.dataset.partrow === n); });
    }
    pins.forEach(function (p) {
      ['mouseenter', 'focus'].forEach(function (e) { p.addEventListener(e, function () { set(p.dataset.part, true); }); });
      ['mouseleave', 'blur'].forEach(function (e) { p.addEventListener(e, function () { set(p.dataset.part, false); }); });
    });
    rows.forEach(function (r) {
      r.addEventListener('mouseenter', function () { set(r.dataset.partrow, true); });
      r.addEventListener('mouseleave', function () { set(r.dataset.partrow, false); });
    });
  }

  /* ---- Team sport filter -------------------------------------------------- */
  function initTeamFilter() {
    var bar = document.querySelector('[data-team-filter]');
    if (!bar) return;
    var riders = [].slice.call(document.querySelectorAll('.sear-rider'));

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('.sear-chip');
      if (!btn) return;
      var sport = btn.dataset.sport;

      bar.querySelectorAll('.sear-chip').forEach(function (c) {
        var on = c === btn;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      riders.forEach(function (r) {
        r.hidden = sport !== 'all' && (r.dataset.sports || '').indexOf(sport) === -1;
      });
    });
  }

  /* ---- Sticky buy bar ----------------------------------------------------- */
  function initBuyBar() {
    var bar = document.querySelector('[data-buybar]');
    if (!bar) return;
    bar.hidden = false;

    // On a product page the bar is only useful once the real Add to bag has
    // scrolled away - showing it while the button is on screen just covers
    // content with a duplicate of itself. 420px was an arbitrary guess that
    // was wrong on every viewport except the one it was written on.
    var primary = document.querySelector('.sear-pdp__add');

    if (primary && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.classList.toggle('is-up', !e.isIntersecting); });
      }, { rootMargin: '0px 0px -40px 0px' });
      io.observe(primary);
      return;
    }

    // Elsewhere (or without IntersectionObserver): once past the first screen.
    function sync() {
      bar.classList.toggle('is-up', window.scrollY > window.innerHeight * 0.6);
    }
    sync();
    window.addEventListener('scroll', sync, { passive: true });
  }


  /* ---- Cart drawer -------------------------------------------------------
     Intercepts add-to-cart so the customer stays on the page. Everything here
     degrades: without fetch the product form posts normally to /cart, and the
     buy bar falls back to being a link to the product page.
  ------------------------------------------------------------------------- */
  function initCart() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || !window.fetch) return;

    var cfgEl = document.querySelector('[data-cart-config]');
    var cfg = { freeShippingQty: 2, moneyFormat: '£{{amount}}' };
    try { cfg = Object.assign(cfg, JSON.parse(cfgEl.textContent)); } catch (e) {}

    var panel = drawer.querySelector('.sear-cd__panel');
    var body = drawer.querySelector('[data-cart-body]');
    var foot = drawer.querySelector('[data-cart-foot]');
    var empty = drawer.querySelector('[data-cart-empty]');
    var subtotal = drawer.querySelector('[data-cart-subtotal]');
    var ship = drawer.querySelector('[data-cart-ship]');
    var shipMsg = drawer.querySelector('[data-cart-ship-msg]');
    var shipBar = drawer.querySelector('[data-cart-ship-bar]');
    var shipFill = drawer.querySelector('[data-cart-ship-fill]');
    var lastFocus = null;

    function money(cents) {
      var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return cfg.moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, v);
    }

    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      // Force a style flush so the transition has a committed start state, then
      // open in the same task. requestAnimationFrame would be the obvious way to
      // wait a frame, but it does not fire in a hidden or throttled tab - which
      // left the drawer open-but-offscreen after an add, so the customer saw
      // nothing happen and clicked again.
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      panel.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      var done = function () { drawer.hidden = true; };
      if (reduceMotion) { done(); } else { setTimeout(done, 240); }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function setCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    }

    function renderShipping(cart) {
      var need = cfg.freeShippingQty;
      if (!need || need < 2 || !cart.item_count) { ship.hidden = true; return; }
      ship.hidden = false;
      var short = need - cart.item_count;
      var pct = Math.min(100, Math.round((cart.item_count / need) * 100));
      shipFill.style.width = pct + '%';
      shipBar.setAttribute('aria-valuenow', String(pct));
      if (short > 0) {
        shipMsg.innerHTML = 'Add ' + short + ' more pair' + (short > 1 ? 's' : '') +
          ' for <strong>free delivery</strong>.';
        shipBar.classList.remove('is-done');
      } else {
        shipMsg.innerHTML = '<strong>Free delivery unlocked.</strong>';
        shipBar.classList.add('is-done');
      }
    }

    function render(cart) {
      setCount(cart.item_count);
      renderShipping(cart);

      if (!cart.item_count) {
        body.innerHTML = '';
        foot.hidden = true;
        empty.hidden = false;
        return;
      }
      empty.hidden = true;
      foot.hidden = false;
      subtotal.textContent = money(cart.items_subtotal_price);

      body.innerHTML = cart.items.map(function (it) {
        var img = it.image
          ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" width="64" height="64">'
          : '';
        return '<div class="sear-cd__item" data-key="' + it.key + '">' +
          '<div class="sear-cd__thumb">' + img + '</div>' +
          '<div class="sear-cd__info">' +
            '<p class="sear-cd__name">' + it.product_title + '</p>' +
            '<p class="sear-cd__price">' + money(it.final_line_price) + '</p>' +
            '<div class="sear-cd__qty">' +
              '<button type="button" data-cart-step="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<span aria-live="polite">' + it.quantity + '</span>' +
              '<button type="button" data-cart-step="1" aria-label="Increase quantity">+</button>' +
              '<button type="button" class="sear-cd__remove" data-cart-remove>Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');
    }

    function refresh(openAfter) {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
                   { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); if (openAfter) open(); })
        .catch(function () {});
    }

    function change(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(render).catch(function () {});
    }

    function add(id, qty, btn) {
      var label = btn && btn.textContent;
      if (btn) { btn.disabled = true; btn.dataset.label = label; btn.textContent = 'Adding…'; }
      var errBox = document.querySelector('[data-cart-error]');
      if (errBox) { errBox.hidden = true; errBox.textContent = ''; }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return refresh(true);
        })
        .catch(function () {
          // Say so rather than failing silently. Only fall back to a full page
          // load if there is nowhere on the page to show the message.
          var box = document.querySelector('[data-cart-error]');
          if (box) {
            box.textContent = 'Sorry - we could not add that to your bag. Please try again, or refresh the page.';
            box.hidden = false;
            box.scrollIntoView({ block: 'nearest' });
          } else {
            window.location.href = '/cart';
          }
        })
        .then(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to bag'; }
        });
    }

    // Product form
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var id = form.querySelector('[name="id"]');
        if (!id) return;
        e.preventDefault();
        var q = form.querySelector('[name="quantity"]');
        add(id.value, q ? parseInt(q.value, 10) || 1 : 1, form.querySelector('[type="submit"]'));
      });
    });

    // Sticky buy bar. It mirrors the product form when there is one, so the
    // quantity a customer chose is respected and a sold-out variant cannot be
    // added from the bar after the main button has been disabled.
    document.querySelectorAll('[data-cart-add]').forEach(function (btn) {
      var form = document.querySelector('form[action*="/cart/add"]');
      var primary = document.querySelector('.sear-pdp__add');

      if (primary && primary.disabled) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('is-disabled');
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.getAttribute('aria-disabled') === 'true') return;
        var id = btn.dataset.cartAdd;
        var qty = parseInt(btn.dataset.cartQty, 10) || 1;
        if (form) {
          var fid = form.querySelector('[name="id"]');
          var fq = form.querySelector('[name="quantity"]');
          if (fid) id = fid.value;
          if (fq) qty = parseInt(fq.value, 10) || 1;
        }
        add(id, qty, btn);
      });
    });

    // Open from the header bag link
    document.querySelectorAll('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); refresh(true); });
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { close(); return; }
      var item = e.target.closest('[data-key]');
      if (!item) return;
      var key = item.dataset.key;
      var step = e.target.closest('[data-cart-step]');
      if (step) {
        var now = parseInt(item.querySelector('.sear-cd__qty span').textContent, 10) || 1;
        change(key, Math.max(0, now + parseInt(step.dataset.cartStep, 10)));
      } else if (e.target.closest('[data-cart-remove]')) {
        change(key, 0);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });

    refresh(false);
  }


  /* ---- Product gallery -------------------------------------------------
     Thumbnails switch which already-rendered slide is visible, so there is no
     request on click. Without JS the CSS leaves every slide visible and the
     thumbnails behave as in-page anchors.
  --------------------------------------------------------------------- */
  function initGallery() {
    var stage = document.querySelector('[data-pdp-stage]');
    var thumbs = document.querySelector('[data-pdp-thumbs]');
    if (!stage || !thumbs) return;

    var slides = stage.querySelectorAll('[data-pdp-slide]');
    var buttons = thumbs.querySelectorAll('[data-pdp-thumb]');
    if (slides.length < 2) return;

    function show(n) {
      slides.forEach(function (el) {
        el.classList.toggle('is-active', el.dataset.pdpSlide === n);
      });
      buttons.forEach(function (el) {
        var on = el.dataset.pdpThumb === n;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pdp-thumb]');
      if (!btn) return;
      // The href is the no-JS fallback; with JS we swap in place instead of jumping.
      e.preventDefault();
      show(btn.dataset.pdpThumb);
    });

    // Swipe on the stage. Touch phones expect to move through a gallery with a
    // thumb, not by hunting for a thumbnail. Tracked with pointer events so it
    // works for touch and pen alike, and a vertical drag is left alone so the
    // page still scrolls normally.
    var swipe = null;

    function currentIndex() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function step(delta) {
      var next = currentIndex() + delta;
      if (next < 0 || next >= slides.length) return;          // no wrap, no rubber-band
      show(slides[next].dataset.pdpSlide);
    }

    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;                  // mouse users have thumbnails
      swipe = { x: e.clientX, y: e.clientY, t: Date.now() };
    }, { passive: true });

    stage.addEventListener('pointerup', function (e) {
      if (!swipe) return;
      var dx = e.clientX - swipe.x;
      var dy = e.clientY - swipe.y;
      var quick = Date.now() - swipe.t < 800;
      swipe = null;
      // Horizontal intent only: ignore anything that looks like a scroll.
      if (!quick || Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      step(dx < 0 ? 1 : -1);
    }, { passive: true });

    stage.addEventListener('pointercancel', function () { swipe = null; }, { passive: true });

    // Arrow keys move through the gallery once a thumbnail has focus.
    thumbs.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var btn = e.target.closest('[data-pdp-thumb]');
      if (!btn) return;
      e.preventDefault();
      var i = Array.prototype.indexOf.call(buttons, btn);
      var next = buttons[e.key === 'ArrowRight' ? i + 1 : i - 1];
      if (next) { next.focus(); show(next.dataset.pdpThumb); }
    });

    show('1');
  }


  /* ---- Image lightbox ----------------------------------------------------
     The gallery had no way to see an image larger, which matters for a product
     whose whole story is the size system. Built as a real modal: focus moves
     in and is restored on close, Escape closes, Tab is trapped, and the
     trigger is a button so it is reachable by keyboard.
  ----------------------------------------------------------------------- */
  function initLightbox() {
    var trigger = document.querySelector('[data-pdp-zoom]');
    var stage = document.querySelector('[data-pdp-stage]');
    if (!trigger || !stage) return;

    var box = null, lastFocus = null;

    function close() {
      if (!box) return;
      box.remove();
      box = null;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function open() {
      var slide = stage.querySelector('.sear-pdp__slide.is-active') || stage.querySelector('.sear-pdp__slide');
      if (!slide) return;
      lastFocus = document.activeElement;

      box = document.createElement('div');
      box.className = 'sear-lb';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Product image');
      box.innerHTML =
        '<div class="sear-lb__scrim" data-lb-close></div>' +
        '<figure class="sear-lb__fig">' +
          '<button type="button" class="sear-lb__close" data-lb-close aria-label="Close image">' +
            '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<img src="" alt="">' +
          '<figcaption class="sear-lb__cap"></figcaption>' +
        '</figure>';

      var img = box.querySelector('img');
      img.src = slide.dataset.full || slide.querySelector('img').src;
      img.alt = slide.dataset.fullAlt || '';
      box.querySelector('.sear-lb__cap').textContent = img.alt;

      document.body.appendChild(box);
      document.documentElement.style.overflow = 'hidden';
      box.querySelector('.sear-lb__close').focus();

      box.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]')) close();
      });

      box.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') return;
        // Only one focusable element, so keep focus on it.
        e.preventDefault();
        box.querySelector('.sear-lb__close').focus();
      });
    }

    trigger.addEventListener('click', open);
  }

  function init() {
    initReveal();
    initMobileNav();
    initQty();
    initCountUp();
    initParts();
    initTeamFilter();
    initBuyBar();
    initCart();
    initGallery();
    initLightbox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
